<!-- 
    가장 최근의 SnapshotData를 기준으로 Type별 Status의 현황을 보여주는 그래프

 -->

 <template>
    <!-- <b-row class="w-100 d-flex justify-content-center align-items-center flex-nowrap h-80 flex-column" style="margin: 0;"> -->
    <b-row class="w-100 h-80" style="margin: 0;">
        <div class="target-keyword" style="font-weight: bold;">
            <span class="target-label">Keyword : 수정, 삭제</span>
        </div>
        <div class="target-content">
            <div class="count-area">
                <div style="border-bottom: 3px solid black;">
                    <span class="count-label">Target</span>
                    <span class="count-data target">{{ animateTargetCount | numberFormat }}</span>
                </div>
                <div>
                    <span class="count-label">Total</span>
                    <span class="count-data total">{{ animateTotalCount | numberFormat }}</span>
                </div>
            </div>
            <span class="percentage">{{ animatePercentage }}%</span>
        </div>
    </b-row>
    <!-- <b-row class="w-100 d-flex justify-content-center align-items-center flex-nowrap" :class="isFlexible ? 'h-100' : 'h-80'" style="margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="series" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        
        <div class="change-today-graph h-100" style="flex:3; position: relative;" :style="isFlexible ? 'padding: 20px 0;' : 'padding: 0;'">
            <apexchart v-if="series" id="chart"
            width="100%" height="100%" ref="apexchart" 
            :options="chartOptions"
                :series="series" />
        </div>
        <div v-if="isFlexible && tableData" class="d-flex align-items-center justify-content-center flex-column h-100" style="flex:1">
            <ChartTable :tableData="tableData"/>
        </div>
    </b-row> -->
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
    name: 'SpecificKeyword',
    props: [
        'series',
    ],
    components: {
        apexchart: VueApexCharts,
    },
    created() {
        this.series.forEach(item => {
            switch (item.name) {
                case "수정, 삭제 미포함":
                    this.totalCount = item.data;
                    break;
            
                case "수정, 삭제 포함":
                    this.targetCount = item.data;
                    break;
                case "비율":
                    this.percentage = item.data; 
                    break;
            }
        });

        this.showGraph = true;
    },
    mounted() {
        this.animateValue('animateTargetCount', this.targetCount);
        this.animateValue('animateTotalCount', this.totalCount);
        this.animateValue('animatePercentage', this.percentage);
    },
    data() {
        return {
            loading : false,
            showGraph: false,
            targetCount: 0,
            totalCount: 0,
            percentage: 0,
            animateTargetCount: 0,
            animateTotalCount: 0,
            animatePercentage: 0,
        }
    },
    filters: {
        numberFormat(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    },
    methods: {
        // 자바스크립트 Closure 때문에 외부변수의 값이 변화하지 않아
        // startValue를 Object로 받음
        animateValue(valueName, targetValue) {
            const increment = Math.ceil(targetValue * 0.06);

            const step = () => {
                if(this[valueName] < targetValue) {
                    this[valueName] += increment;

                    if(this[valueName] > targetValue) {
                        this[valueName] = targetValue;
                    }
                    requestAnimationFrame(step);
                }
            }
            requestAnimationFrame(step);
        }
    },
}
</script>
<style scoped>
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');
* {
    font-family: 'NanumGothic';
}
.target-content {
    display: flex;
    width: 100%;
    justify-content: center;
    height: fit-content;
    margin-bottom: auto;
}
.count-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 2;
}
.count-area div {
    width: 90%;
    padding-left: 1.5rem;
}
.count-area .count-label {
    display: inline-block;
    font-size: 1.3rem;
    /* font-weight: bold; */
    width: 30%;
}
.count-area .count-data {
    display: inline-block;
    padding: 0.3rem 0;
    width: 60%;
    text-align: center;

}
.count-data.target {
    color: #176BA0;
    font-size: 2.4rem;
    font-weight: bold;
}
.target-keyword {
    color: #142459;
    width: 100%;
    height: fit-content;
}
.count-data.total {
    color: #142459;
    font-size: 1.5rem;
}
.percentage {
    color: #176BA0;
    font-size: 2.5rem;
    font-weight: bold;
    flex:1;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
}

.count-data {
    font-size: 2.5rem;
    font-weight: 600;
}

.h-80 {
    padding-top: 10px;
    height: 80%;
}
.h-90 {
    height: 90%;
}
</style>
<style>
/* 커스텀 툴팁 스타일 */
.change-today-graph .apexcharts-tooltip {
    border-radius: 100px;
    border: 1px solid #FFF;
    background: transparent;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.20);
}
.change-today-graph .apexcharts-tooltip-series-group.apexcharts-active {
    padding: 0 12px;
}
</style>